<template>
  <div>
    <div class="page-loading" v-show="$store.state.pageLoading">
      <van-loading type="spinner" size="34" color="#D8B278" vertical> 加载中... </van-loading>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted() {
    // 监听窗口高度变化，如果高度比初始状态小，则说明键盘弹起。可以用于解决fixed定位元素，被键盘推上去的问题
    this.winHeight = document.body.clientHeight || document.documentElement.clientHeight
    window.addEventListener('resize', () => {
      const winHeight = document.body.clientHeight || document.documentElement.clientHeight
      this.$store.commit('setKeyboardUp', winHeight < this.winHeight)
    })
  },
}
</script>

<style>
#app {
  font-family: PingFang SC, PingFangSC-Regular, 'Avenir', Helvetica, Arial, sans-serif;
  /* font-family: PingFangSC, PingFangSC-Regular,'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.page-loading {
  position: fixed;
  left: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
</style>
